<template>
    <div>
      <router-view></router-view> <!-- 子路由会在这里渲染 -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'Config',
  };
  </script>
  
  <style scoped>
  .el-menu {
    margin-bottom: 20px;
  }
  </style>